"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const usePostMessage_1 = require("./usePostMessage");
exports.default = () => (0, usePostMessage_1.default)('hideLoader');
